import api from './api';

const startAudit = (clientId) => {
  return api.post('/forensic/start-audit', { client_id: clientId });
};

const exportAudit = (clientId) => {
  return api.get(`/forensic/export-audit/${clientId}`, {
    responseType: 'blob', // Important for handling file downloads
  });
};

const forensicService = {
  startAudit,
  exportAudit,
};

export default forensicService;